<style scoped>
  .formulario{  min-width: 200px;  }
  footer{  padding-top: 17px  }
</style>

<template>
  <b-dropdown position="is-bottom-left">
    <a class="button is-light" slot="trigger">
      <b-icon icon="magnify" />
    </a>

    <b-dropdown-item custom class="has-text-left">
      <form @submit.stop.prevent="$emit('filtrar')">

        <div class="formulario">
          <slot/>
        </div>

        <footer>
          <button class="button is-primary" :class="{'is-loading': loading}" type="submit">
            <b-icon icon="magnify" />
            <span>Filtrar</span>
          </button>

          <button class="button" :disabled="loading" @click="$emit('limpar')" type="button">
            Limpar
          </button>
        </footer>
      </form>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    props: ['loading']
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalFiltro.vue